import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['navigation.component.css']
})

export class NavigationComponent {
  portalUrl: string;

  constructor() {
    this.portalUrl = environment.link;
  }
}
